import { render, staticRenderFns } from "./CustomFulfillmentLocation.vue?vue&type=template&id=618aa3ae"
import script from "./CustomFulfillmentLocation.vue?vue&type=script&lang=js"
export * from "./CustomFulfillmentLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports